var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.machineName)?_c('button',{staticClass:"fit20-font-light chart-button",style:(_vm.backgroundColor),attrs:{"translate":"no"},on:{"click":function($event){return _vm.$emit('toggle-line', _vm.index)}}},[_vm._v(" "+_vm._s(_vm.machineName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }